import "@/App.css";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { PriorityServices } from "@/components/landing/PriorityServices";
import { OtherServices } from "@/components/landing/OtherServices";
import { Coverage } from "@/components/landing/Coverage";
import { About } from "@/components/landing/About";
import { ContactFooter } from "@/components/landing/ContactFooter";
import { StickyCallButton } from "@/components/landing/StickyCallButton";

function App() {
  return (
    <div className="App min-h-screen bg-[#FAF9F6]" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <PriorityServices />
        <OtherServices />
        <Coverage />
        <About />
      </main>
      <ContactFooter />
      <StickyCallButton />
    </div>
  );
}

export default App;
